import { dateToAnsi, DATE_FORMATS } from '@utils';

export const queryParams = (filtros) => {
  if (!filtros) return '';

  const query = [];
  const { id, page, startDate, endDate } = filtros;

  if (startDate && endDate) {
    query.push(`startDate=${dateToAnsi(startDate, null, DATE_FORMATS.ANSI_DATE)}`);
    query.push(`endDate=${dateToAnsi(endDate, null, DATE_FORMATS.ANSI_DATE)}`);
  }
  if (id && id > 0) query.push(`id=${id}`);

  query.push(`page=${page}`);

  if (query.length === 0) return '';
  return '?' + query.join('&');
};
